import type { SVGProps } from 'react';
const DawnFlagMX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-MX_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-MX_svg__a)">
      <path fill="#E3283E" d="M14.667 0H22v16h-7.333z" />
      <path fill="#128A60" fillRule="evenodd" d="M0 16h7.333V0H0z" clipRule="evenodd" />
      <path
        fill="#8C9157"
        d="M9.571 7.467a.667.667 0 1 0-1.333 0zm.04 2.42a.667.667 0 0 0 .678-1.148zm2.152-1.18a.667.667 0 1 0 .728 1.117zm1.998-1.24a.667.667 0 1 0-1.333 0zm-5.523 0c0 1.03.55 1.934 1.372 2.42l.679-1.148a1.47 1.47 0 0 1-.718-1.272zm4.253 2.357a2.81 2.81 0 0 0 1.27-2.357h-1.333c0 .524-.267.98-.665 1.24z"
      />
      <path
        fill="#C59262"
        fillRule="evenodd"
        d="M11 8.533c.578 0 1.047-.716 1.047-1.6 0-.883-.469-1.6-1.047-1.6-.579 0-1.048.717-1.048 1.6s.47 1.6 1.048 1.6"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagMX;
